"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  var apptEl = document.querySelector('.book-appointment');
  var locationItem = document.querySelector('.doctor-bio-masthead__locations');
  if (apptEl) {
    var triggerEl = document.querySelector('.book-appt_placeholder');
    var handler = function handler(entries) {
      if (!entries[0].isIntersecting) {
        apptEl.classList.add('enabled');
      } else {
        apptEl.classList.remove('enabled');
      }
    };
    // create the observer
    var observer = new window.IntersectionObserver(handler);
    observer.observe(triggerEl);
  }

  // Email input validation
  var formEl = document.querySelector('.doctor-bio-masthead__appointment form');
  if (formEl) {
    var inputEl = document.querySelector('.doctor-bio-masthead__appointment input.email');
    var submitBtnEl = document.querySelector('.doctor-bio-masthead__appointment button');
    inputEl.addEventListener('input', function (event) {
      if (inputEl.value.length == 0) {
        submitBtnEl.disabled = true;
      } else {
        submitBtnEl.disabled = false;
      }
    });
  }
  if (locationItem != null) {
    //Distance calculator for locations based on browser geolocation
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    }
    function showPosition(position) {
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;
      if (lat && lng) {
        setDriveDistances(lat, lng);
        updateOrderByDistance();
      }
    }
    function setDriveDistances(lat, lng) {
      document.querySelectorAll(".locations_distanceFromVisitor").forEach(function (d) {
        var uLat = d.getAttribute("lat");
        var uLng = d.getAttribute("lng");
        var fallBackOveride = 9999;
        //Fallbacks for blank geo location values from blank location item for department
        if (uLat == "") {
          uLat = fallBackOveride;
        }
        if (uLng == "") {
          uLng = fallBackOveride;
        }
        if (uLat && uLng) {
          var distance = get2LatLongDistance(uLat, uLng, lat, lng);
          if (uLng != fallBackOveride | uLat != fallBackOveride) {
            d.innerHTML = Math.ceil(distance) + " mi";
          }
          d.setAttribute('distance', distance);
        }
        console.log("Distance ", d);
      });
    }
    function get2LatLongDistance(lat1, lon1, lat2, lon2) {
      if (lat1 == lat2 && lon1 == lon2) {
        return 0;
      } else {
        var radlat1 = Math.PI * lat1 / 180;
        var radlat2 = Math.PI * lat2 / 180;
        var theta = lon1 - lon2;
        var radtheta = Math.PI * theta / 180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
          dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        return dist;
      }
    }
  }
});